export default {
  methods: {
    formatUnityTooltip(unity = null, fallbackValue = null, field = null, emptyValue = '-') {
      const unityValue = unity && field ? unity[field] : null;
      const value = unityValue !== null && unityValue !== undefined && unityValue !== ''
        ? unityValue
        : fallbackValue;

      return value !== null && value !== undefined && value !== ''
        ? value
        : emptyValue;
    },
  },
};
